export const URLS = Object.freeze({
  GIB_LEARN: 'https://www.va.gov/education/about-gi-bill-benefits/',
  GIB_APPLY: 'https://www.va.gov/education/how-to-apply/',
  DBP_LEARN: 'https://skillbridge.osd.mil/',
  ECC_LEARN:
    'https://www.va.gov/careers-employment/education-and-career-counseling/',
  ECC_APPLY:
    'https://www.va.gov/careers-employment/education-and-career-counseling/apply-career-guidance-form-25-8832/introduction/',
  FHV_LEARN: 'https://www.opm.gov/fedshirevets/',
  SVC_LEARN:
    'https://www.va.gov/careers-employment/veteran-owned-business-support/',
  TAP_LEARN: 'https://www.dodtap.mil/dodtap/app/home',
  VRE_LEARN: 'https://www.va.gov/careers-employment/vocational-rehabilitation/',
  VRE_APPLY:
    'https://www.va.gov/careers-employment/vocational-rehabilitation/how-to-apply',
  VSC_LEARN: 'https://www.va.gov/careers-employment/vetsuccess-on-campus/',
  DHS_LEARN: 'https://www.va.gov/housing-assistance/disability-housing-grants/',
  DHS_APPLY:
    'https://www.va.gov/housing-assistance/disability-housing-grants/how-to-apply/',
  VAP_LEARN: 'https://www.va.gov/pension/eligibility/',
  VAP_APPLY: 'https://www.va.gov/pension/how-to-apply/',
  MHC_LEARN:
    'https://www.va.gov/health-care/health-needs-conditions/mental-health/',
  FMP_LEARN: 'https://www.va.gov/health-care/foreign-medical-program/',
  VGL_LEARN: 'https://www.va.gov/life-insurance/options-eligibility/vgli/',
  VAL_LEARN: 'https://www.va.gov/life-insurance/options-eligibility/valife/',
  VAL_APPLY: 'https://insurance.va.gov/VALIFE/Fiduciary/',
  DIS_LEARN: 'https://www.va.gov/disability/',
  DIS_APPLY: 'https://www.va.gov/disability/how-to-file-claim/',
  COE_LEARN: 'https://www.va.gov/housing-assistance/home-loans/',
  COE_APPLY:
    'https://www.va.gov/housing-assistance/home-loans/how-to-request-coe/',
  VAH_LEARN: 'https://www.va.gov/health-care/',
  VAH_APPLY: 'https://www.va.gov/health-care/how-to-apply/',
  BUR_LEARN: 'https://www.va.gov/burials-memorials/eligibility/',
  BUR_APPLY: 'https://www.va.gov/burials-memorials/pre-need-eligibility/',
  TGI_LEARN:
    'https://www.va.gov/education/transfer-post-9-11-gi-bill-benefits/',
  DCU_LEARN: 'https://www.va.gov/discharge-upgrade-instructions/',
  SVB_LEARN:
    'https://discover.va.gov/external-resources/?_resource_type=state-veterans-affairs-office',
  ENPP_LEARN:
    'https://www.dol.gov/agencies/vets/programs/tap/employment-navigator-partnership',
});
